module.exports = __webpack_public_path__ + "media/Ill be there.2c8b2315.mp3";